module.exports = __webpack_public_path__ + "img/amex.d4f5ee28.png";